import Login from './Login';
import Page404 from './Page404';
import Page500 from './Page500';
import Register from './Register';
import Landing from './Landing';
import About from './About';
import FAQ from './FAQ';
import Contact from './Contact';

/* Footer pages */
import AppGuide from './AppGuide';
import Architecture from './Architecture';
import CustomDev from './CustomDev';
import Ecommerce from './Ecommerce';
import Education from './Education';
import Entertainment from './Entertainment';
import Feature from './Feature';
import Media from './Media';
import Medical from './Medical';
import PlatformGuide from './PlatformGuide';
import Pricing from './Pricing';
import Privacy from './Privacy';
import RealEstate from './RealEstate';
import Retail from './Retail';
import Sports from './Sports';
import Support from './Support';
import ToS from './ToS';
import Training from './Training';
import Travel from './Travel';

export {
  Login, Page404, Page500, Register, Landing, About, FAQ, Contact
};

/* footer pages */
export {
  AppGuide, Architecture, CustomDev, Ecommerce, Education, Entertainment, Feature, Media, PlatformGuide 
};

export {
  Pricing, Privacy, RealEstate, Retail, Sports, Support, ToS, Training, Travel, Medical
};



// WEBPACK FOOTER //
// ./src/views/Pages/index.js